module.exports = __webpack_public_path__ + "static/media/founders-grotesk-web-light.11b74bb7.woff2";